import { ColumnConfig } from '@components/design/migrated/Table';
import { ColumnHeader, ColumnHeaderDisplayName } from '@models/Products';
import { FocusArea } from '../Types';

export const getProductsColumns = (selectedFocusArea: FocusArea): ColumnConfig[] => {
  return [
    {
      headerKey: selectedFocusArea === FocusArea.market ? ColumnHeader.marketRank : ColumnHeader.retailerRank,
      name: ColumnHeaderDisplayName[ColumnHeader.ranking],
      compact: true,
    },
    {
      headerKey: ColumnHeader.itemName,
      name: ColumnHeaderDisplayName[ColumnHeader.itemName],
    },
    {
      headerKey: ColumnHeader.marketRevenue,
      name: ColumnHeaderDisplayName[ColumnHeader.marketRevenue],
      compact: true,
    },
    {
      headerKey: ColumnHeader.marketVolume,
      name: ColumnHeaderDisplayName[ColumnHeader.marketVolume],
      compact: true,
    },
    {
      headerKey: ColumnHeader.retailerRevenue,
      name: ColumnHeaderDisplayName[ColumnHeader.retailerRevenue],
      compact: true,
    },
    {
      headerKey: ColumnHeader.retailerVolume,
      name: ColumnHeaderDisplayName[ColumnHeader.retailerVolume],
      compact: true,
    },
    {
      headerKey: ColumnHeader.firstActivity,
      name: ColumnHeaderDisplayName[ColumnHeader.firstActivity],
    },
    {
      headerKey: ColumnHeader.marketShare,
      name: ColumnHeaderDisplayName[ColumnHeader.marketShare],
    },
  ];
};
